export const COMMAND_CENTER_MARK_LOADED = 'commandCenter/MARK_LOADED';

/**
 * Enum of load-status keys — one per fetch thunk that backs a skeletonised zone.
 * Import this in both the thunks (to dispatch markCommandCenterLoadedAction)
 * and the zone components (to read loaded[KEY] via selectCommandCenterLoaded).
 * Using a shared enum avoids string-literal duplication across the two call sites.
 *
 * Key-to-zone mapping:
 *   SHOP_PIPELINE  → ShopPipelineZone
 *   ACTION_ITEMS   → ActionCenterCard + PriorityQueueZone (same thunk)
 *   ACTIVITY_FEED  → ActivityFeedZone
 *   TURN_TIME_TREND → TurnTimeTrendZone + SlaGaugeZone (same slice)
 *   TURN_TIME_STAGES → TurnTimeStagesZone
 *   SUMMARY        → KpiStripZone + CompanyHeroZone (same slice)
 *   EARNINGS       → RecapHeroZone (lead EARNED pillar)
 *   LOCK_EXPOSURE  → (lock-desk inputs; no skeletonised zone of its own today)
 *   PIPELINE_FUNNEL → PipelineFunnelZone
 *   RATE_SHEET_MOVEMENT → PricingBandZone
 *   MONTHLY_VOLUME → CompanyVolumeZone
 *   FILE_QUALITY   → FileQualityZone
 *   CONDITION_HEATMAP → ConditionHeatmapZone (DEV-4173)
 *   QUEUE_DEPTH    → QueueDepthZone (DEV-4175)
 *   EPO_WATCH      → EpoWatchZone (DEV-4176)
 *   DISCLOSURE_TIMING → DisclosureTimingZone (DEV-4174)
 *   CLOSING_THIS_WEEK → ClosingThisWeekZone (DEV-4177)
 */
export const CommandCenterLoadKey = {
  SHOP_PIPELINE: 'SHOP_PIPELINE',
  ACTION_ITEMS: 'ACTION_ITEMS',
  ACTIVITY_FEED: 'ACTIVITY_FEED',
  TURN_TIME_TREND: 'TURN_TIME_TREND',
  TURN_TIME_STAGES: 'TURN_TIME_STAGES',
  SUMMARY: 'SUMMARY',
  EARNINGS: 'EARNINGS',
  LOCK_EXPOSURE: 'LOCK_EXPOSURE',
  PIPELINE_FUNNEL: 'PIPELINE_FUNNEL',
  RATE_SHEET_MOVEMENT: 'RATE_SHEET_MOVEMENT',
  MONTHLY_VOLUME: 'MONTHLY_VOLUME',
  FILE_QUALITY: 'FILE_QUALITY',
  CONDITION_HEATMAP: 'CONDITION_HEATMAP',
  QUEUE_DEPTH: 'QUEUE_DEPTH',
  EPO_WATCH: 'EPO_WATCH',
  DISCLOSURE_TIMING: 'DISCLOSURE_TIMING',
  CLOSING_THIS_WEEK: 'CLOSING_THIS_WEEK',
};

/**
 * Marks a command-center slice as having completed its fetch (success or 403).
 * Dispatch this in a `finally` block inside the thunk so it fires even when the
 * error is swallowed by catchAsyncActionError / skipResponseInterceptor.
 *
 * @param {string} key — one of CommandCenterLoadKey
 * @returns {{ type: string, payload: { key: string } }}
 */
export const markCommandCenterLoadedAction = key => ({
  type: COMMAND_CENTER_MARK_LOADED,
  payload: { key },
});
